import { Component } from '@angular/core';
import { AppInitializerService } from 'src/app/services/app-initializer.service';

@Component({
  selector: 'app-initializer-loader',
  templateUrl: './app-initializer-loader.component.html',
  styleUrls: ['./app-initializer-loader.component.css']
})
export class AppInitializerLoaderComponent {

  constructor(
    public appInitializerService: AppInitializerService
  ) { }
}
